import * as React from "react";
import { useState, useCallback } from 'react';
import {
    List,
    TextInput,
    SimpleForm,
    TextField,
    Edit,
    FunctionField,
    Datagrid,
    TopToolbar,
    Show,
    ShowButton,
    Toolbar,
    SaveButton,
    ReferenceManyField,
    required,
    NumberInput,
    TabbedShowLayout,
    ReferenceField,
    FilterList,
    FilterListItem,
    EditButton
} from 'react-admin';

import { RichTextInput } from 'ra-input-rich-text';
import { RowForm } from "@react-admin/ra-editable-datagrid";

import { iconStyle } from '../shared/Styles/iconsStyles';
import { fieldTabForShow } from '../shared/Styles/fieldsStyles';

import Typography from "@material-ui/core/Typography";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import NoteIcon from '@mui/icons-material/Note';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import Button from '@mui/material/Button';
import BusinessIcon from '@mui/icons-material/Business';
import QuizIcon from '@mui/icons-material/Quiz';
import CategoryIcon from '@mui/icons-material/Category';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
// import Avatar from '@mui/material/Avatar';
// import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

// Importo il css per i Bottoni
import { saveButtonCss, showButtonCss, editButtonCss } from '../shared/Styles/buttonStyles';
import { EditDialog } from '@react-admin/ra-form-layout';
import { listCss } from '../shared/Styles/listStyles';

/* TODO: da creare componente custom */
/* const CustomAvatarImage = ({ source, label }) => {
    const record = useRecordContext();
    if (!record) return null;

    return (
        <Box height="80%" width="80%" display="flex" justifyContent="left" alignItems="top">
            {record[source] ? (
                // <img src={customerImageUrl} alt="Logo cliente" style={{ maxHeight: '80%', maxWidth: '80%', marginTop: '25px', marginBottom: '25px' }} />
                <Avatar alt={label} style={{ width: '100px', height: '100px' }} src={record[source]} />
            ) : (
                <p><Avatar alt="Immagine mancante" style={{ width: '100px', height: '100px' }}><ImageNotSupportedIcon /></Avatar></p>
            )}
        </Box>
    );
}; */

/* const ListActions = () => (
    <TopToolbar>
        <SelectColumnsButton sx={columnsButtonCss} />
    </TopToolbar>
); */

export const DomandeList = props => {

    return (
        <>
            <List
                // pagination={null}
                title={<>
                    <Button>
                        &nbsp;Lista Domande
                    </Button>
                </>}
                exporter={false}
                aside={<EscursioniFilterSidebar />}
                filters={domandeFilters}
                {...props}
                actions={null}
            // perPage={100}
            // filters={aziendaFilters}
            >
                <Datagrid
                    sx={listCss}
                    bulkActionButtons={false}>
                    {/*<WrapperField label="Logo Macro Area">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                        <CustomAvatarImage source="urlLogo" label="Logo" ></CustomAvatarImage>
                    </Box>
                </WrapperField> */}
                    {<TextField label="Codice" source="codiceDomanda" />}
                    <ReferenceField label="Macroarea" link={null} source="tblMacroareeId" reference="tbl-macroaree">
                        <TextField source="descrizione" />
                    </ReferenceField>
                    {<FunctionField source="descrizione" render={record => record && <strong>{record.descrizione}</strong>} />}

                    {/* {<RichTextField label="Ordinamento" source="Ordinamento" />} */}
                    {<EditButton sx={editButtonCss} label="Modifica" />}
                    {/* {<ShowButton sx={showButtonCss} label="Dettaglio" />} */}
                </Datagrid>
            </List>

            {/* DIALOG PER LA MODIFICA DEL TESTO DELLA DOMANDA */}
            <EditDialog fullWidth maxWidth="sm">
                {/*    <SimpleForm>
                    <TextInput source="descrizione" validate={required()} />
                </SimpleForm> */}
                <EditDomandaForm></EditDomandaForm>
            </EditDialog>
        </>
    );
}

/* DIALOG */
const EditDomandaForm = () => {
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const openEditDialog = useCallback(() => {
        setIsEditDialogOpen(true);
    }, []);
    const closeEditDialog = useCallback(() => {
        setIsEditDialogOpen(false);
    }, []);

    return (
        <SimpleForm>
            <Button
                label="Modifica domanda"
                onClick={() => openEditDialog()}
            />
            <EditDialog
                fullWidth
                maxWidth="md"
                isOpen={isEditDialogOpen}
                open={openEditDialog}
                close={closeEditDialog}
                resource="customers"
                record={{ id: 1 }}
            >

                <TextInput source="descrizione" validate={required()} />
            </EditDialog>
        </SimpleForm>
    );
};
/* ****** */

export const DomandeShow = (props) => {
    return (
        <Show title={<>
            <Button>
                &nbsp;Dettaglio Macro Area
            </Button>
        </>} /* actions={<ShowActions />} */ actions={null}>


            {/*                 <Grid item xs={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                </Box>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
            <Grid item xs={12}>
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                Descrizione: <FunctionField source="descrizione" render={record => record && `${record.descrizione}`} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                <NoteIcon />
                                Descrizione Lunga: <TextField label="Descrizione Lunga" source="descrizioneLunga" />
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <TabbedShowLayout>
                <TabbedShowLayout.Tab label="Domante" sx={fieldTabForShow} icon={<QuizIcon sx={iconStyle} />}>

                    <Grid item xs={12}>
                        <ReferenceManyField
                            reference="tbl-domande"
                            target="tblDomandeId"
                            // perPage={1}
                            sort={{ field: 'id', order: 'ASC' }}
                        >

                            <Datagrid
                                noDelete
                                bulkActionButtons={false}
                            /* createForm={null} editForm={<MiaRowForm />} */
                            >
                                {/* <TextField source="id" /> */}
                                {/* <TextField source="tblDomandeId" validate={required()} /> */}
                                <TextField source="codiceDomanda" />
                                <TextField source="descrizione" />
                            </Datagrid>

                        </ReferenceManyField>
                    </Grid>
                </TabbedShowLayout.Tab>



                <TabbedShowLayout.Tab label="Ponderali" sx={fieldTabForShow} icon={<GpsFixedIcon sx={iconStyle} />}>

                    <Grid item xs={12}>
                        {/*                         <Card sx={{ minWidth: 275 }}>
                            <CardContent>
                                <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                        <GpsFixedIcon sx={iconStyle} />
                                        Ponderali
                                    </Box>
                                </Typography>
                            </CardContent>
                        </Card> */}
                        <ReferenceManyField
                            reference="tbl-macroarea-punteggio"
                            target="tblDomandeId"
                            // perPage={1}
                            sort={{ field: 'id', order: 'ASC' }}
                        >

                            <Datagrid
                                noDelete
                                bulkActionButtons={false}
                            // createForm={null} editForm={<MiaRowForm />}
                            >
                                {/* <TextField source="id" /> */}
                                {/* <TextField source="tblDomandeId" validate={required()} /> */}
                                <TextField source="punteggioRisposte" validate={required()} />
                                <TextField source="valoreAssegnato" validate={required()} />
                            </Datagrid>

                        </ReferenceManyField>
                    </Grid>
                </TabbedShowLayout.Tab>
            </TabbedShowLayout>
        </Show>
    );
}

const ShowTopToolbarDettaglio = () => (
    <TopToolbar>
        <ShowButton sx={showButtonCss} label="Dettaglio" />
    </TopToolbar>
);

const ShowActionsForEdit = () => (
    <ShowTopToolbarDettaglio></ShowTopToolbarDettaglio>
);

const MyToolbarEdit = () => (
    <Toolbar>
        <SaveButton sx={saveButtonCss} label="Salva Testo" /* alwaysEnable */ />
    </Toolbar>
);

export const DomandeEdit = (props) => (
    <Edit redirect="list" actions={null}/* actions={<ShowActionsForEdit />} */ title={<>
        <Button>
            &nbsp;MODIFICA DOMANDA
        </Button>
        <FunctionField
            source="codiceDomanda"
            label="Codice Domanda"
            render={record => <span style={{ color: "yellow" }}>{record.codiceDomanda}</span>}
        />
        {/* | Macroarea:
        <ReferenceField label="Macroarea" link={null} source="tblMacroareeId" reference="tbl-macroaree">
            <FunctionField
                source="descrizione"
                label="Descrizione"
                render={record => <span style={{ color: "yellow" }}>{record.descrizione}</span>}
            />
        </ReferenceField> */}
    </>} {...props}>
        <SimpleForm toolbar={<MyToolbarEdit />}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card sx={{ minWidth: 275, boxShadow: 3 }}>
                        <CardContent>
                            <Typography component="div">

                                <Grid item xs={12} sm={12}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1"><strong>Testo Domanda attuale:</strong></Typography>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <TextField label="" source="descrizione" ></TextField>
                                        </Box>
                                    </Grid>

                                </Grid>
                                <Grid container spacing={2}>
                                    {[
                                        { icon: NoteIcon, label: 'Testo Domanda', source: 'descrizione', component: TextInput },
                                    ].map((field, index) => (
                                        <Grid item xs={12} sm={index < 8 ? 6 : 12} key={field.label}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                {React.createElement(field.icon, { sx: { color: 'action.active', mr: 1, my: 0.5, fontSize: '1.25rem' } })}
                                                {React.createElement(field.component, {
                                                    label: field.label,
                                                    source: field.source,
                                                    ...(field.choices ? { choices: field.choices } : {}),
                                                    sx: { width: '100%' },
                                                })}
                                            </Box>
                                        </Grid>
                                    ))}

                                </Grid>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </SimpleForm>
    </Edit>
);

/// Filtri

const EscursioniFilterSidebar = () => (
    <Box
        sx={{
            display: {
                xs: 'none',
                sm: 'block'
            },
            order: -1, // display on the left rather than on the right of the list
            width: '15em',
            marginRight: '1em',
        }}
    >
        <Card>
            <CardContent>
                <DomandaFilterSidebar />
            </CardContent>
        </Card>
    </Box>
);


const DomandaFilterSidebar = () => (
    <Grid container spacing={2}>
        <Grid>
            <Box >
                <FilterList label="Macro Aree" icon={<CategoryIcon />}>
                    <FilterListItem label="Non Definito" value={{ tblMacroareeId: "0" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Allineamento Valoriale" value={{ tblMacroareeId: "1" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Principi" value={{ tblMacroareeId: "2" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Resistenza al Cambiamento" value={{ tblMacroareeId: "3" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Gestione Pressioni" value={{ tblMacroareeId: "4" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Espansività" value={{ tblMacroareeId: "5" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Comprensione" value={{ tblMacroareeId: "6" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Proattività" value={{ tblMacroareeId: "7" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Visione Futura" value={{ tblMacroareeId: "8" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Leadership Indice Naturale" value={{ tblMacroareeId: "9" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="HR Management" value={{ tblMacroareeId: "10" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Determinazione" value={{ tblMacroareeId: "11" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Attitudine alla Vendita" value={{ tblMacroareeId: "12" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Finanze" value={{ tblMacroareeId: "13" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Automotivazione" value={{ tblMacroareeId: "14" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Problem Solving" value={{ tblMacroareeId: "15" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Organizzazione" value={{ tblMacroareeId: "16" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Autodisciplina" value={{ tblMacroareeId: "17" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Successo" value={{ tblMacroareeId: "18" }} icon={<LabelImportantIcon />} />
                    <FilterListItem label="Vuote" value={{ tblMacroareeId: "99" }} icon={<LabelImportantIcon />} />
                </FilterList>
            </Box>
        </Grid>
    </Grid>

);

const domandeFilters = [
    <TextInput label="Codice Domanda" source="codiceDomanda" alwaysOn />
];



